var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 16.27,
    y1: 78.03,
    x2: 63.22,
    y2: 10.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#09ff83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21ff8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#49ff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ffa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 45.6,
    y1: 100.54,
    x2: 96.41,
    y2: 27.98,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.05,106.36a5.92,5.92,0,0,1,0,10.89,9.49,9.49,0,0,1-4,.76H15.16v4.39H10.41V105.6h7.68A9.49,9.49,0,0,1,22.05,106.36Zm-2,7.27a2.28,2.28,0,0,0,.74-1.81A2.31,2.31,0,0,0,20,110a3.29,3.29,0,0,0-2.21-.65H15.16v4.92H17.8A3.35,3.35,0,0,0,20,113.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.2,117.94H32.61v4.46H27.86V105.6h7.68a9.49,9.49,0,0,1,4,.76A6.12,6.12,0,0,1,42.15,115a5.77,5.77,0,0,1-2.44,2.12l3.63,5.28H38.25Zm2.26-8a3.31,3.31,0,0,0-2.21-.65H32.61v4.92h2.64a3.37,3.37,0,0,0,2.21-.63,2.28,2.28,0,0,0,.74-1.81A2.31,2.31,0,0,0,37.46,110Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.3,121.61A8.44,8.44,0,0,1,46,118.49a8.94,8.94,0,0,1,0-9,8.44,8.44,0,0,1,3.34-3.12,10.72,10.72,0,0,1,9.58,0,8.6,8.6,0,0,1,0,15.22,10.72,10.72,0,0,1-9.58,0Zm7.09-3.41A4.28,4.28,0,0,0,58,116.51a5.55,5.55,0,0,0,0-5,4.28,4.28,0,0,0-1.63-1.69,4.73,4.73,0,0,0-4.61,0,4.35,4.35,0,0,0-1.63,1.69,5.55,5.55,0,0,0,0,5,4.35,4.35,0,0,0,1.63,1.69,4.73,4.73,0,0,0,4.61,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.67,109.27V113h7.42v3.67H70.67v5.76H65.92V105.6H79.1v3.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.33,105.6h4.75v16.8H81.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.46,105.6h4.76v13h8v3.77H89.46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.59,118.73v3.67H104.1V105.6h13.18v3.67h-8.47v2.83h7.46v3.56h-7.46v3.07Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.69 5.26 38.31 13.26 80.45 13.26 64 41.76 52.16 21.26 42.93 21.26 64 57.76 94.31 5.26 33.69 5.26"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "76.99 51.26 68.65 65.7 73.27 73.7 81.61 59.26 116 59.26 116 89.26 73.01 89.26 51.01 51.26 4 51.26 4 97.26 59.08 97.26 54.46 89.26 12 89.26 12 59.26 46.39 59.26 68.32 97.26 124 97.26 124 51.26 76.99 51.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9bee0b9714ed23bd7ead0a051af95b56.svg";
export { ForwardRef as ReactComponent };